/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { DocumentText, DocumentsTable } from '@/components/DocumentsTable';
import { Modal, PageHeader } from '@/components/ui';
import { api } from '@/lib/api';

export function DocumentsPage() {
  const [sp, setSp] = useSearchParams();
  const open = sp.get('open');
  const doc = useQuery({ queryKey: ['doc', open], queryFn: () => api.get(`/documents/${open}`), enabled: !!open });
  return (<>
    <PageHeader title="Документы" subtitle="Все документы, к которым у вас есть доступ" /><DocumentsTable filter={{}} />
    <Modal title={doc.data?.title ?? 'Документ'} open={!!open} onClose={() => setSp({})} wide>{open && <DocumentText id={open} />}</Modal>
  </>);
}
